import { Card, CardContent } from "@/components/ui/card";
import { MapPin, Clock, Phone } from "lucide-react";

interface AddressCardProps {
  name: string;
  address: string;
  city: string;
  cep: string;
  complement?: string;
  phone: string;
  horarios: string[];
  showHours?: boolean;
  className?: string;
}

export function AddressCard({
  name,
  address,
  city,
  cep,
  complement,
  phone,
  horarios,
  showHours = true,
  className = ""
}: AddressCardProps) {
  return (
    <Card className={`h-full ${className}`}>
      <CardContent className="p-4 sm:p-6">
        <div className="flex items-start mb-4">
          <MapPin className="w-6 h-6 sm:w-8 sm:h-8 text-green-600 mr-3 mt-1 flex-shrink-0" />
          <div className="flex-1">
            <h3 className="text-lg sm:text-xl font-semibold font-accent mb-2">
              {name}
            </h3>
            <p className="text-gray-600 mobile-text mb-1">
              {address}
              {complement && <><br />{complement}</>}
            </p>
            <p className="text-gray-600 mobile-text mb-1">
              {city}
            </p>
            <p className="text-gray-600 mobile-text">
              CEP: {cep}
            </p>
          </div>
        </div>

        <div className="flex items-center mb-4">
          <Phone className="w-5 h-5 text-green-600 mr-2 flex-shrink-0" />
          <a 
            href={`tel:${phone.replace(/\D/g, '')}`}
            className="text-green-600 hover:text-green-700 font-medium mobile-text"
          >
            {phone}
          </a>
        </div>

        {showHours && (
          <div className="flex items-start">
            <Clock className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" />
            <div>
              {horarios.map((horario, index) => (
                <p key={index} className="text-gray-600 text-sm sm:text-base">
                  {horario}
                </p>
              ))}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}